import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import { EntityPaisesState, entityPaisesAdapter } from './entity-paises.state';

const { selectEntities, selectAll } = entityPaisesAdapter.getSelectors();

export const getError = (state: EntityPaisesState): any => state.error;

export const getIsLoading = (state: EntityPaisesState): boolean =>
  state.isLoading;

export const selectPaisesState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.paises
);

export const selectAllPaises = createSelector(selectPaisesState, selectAll);
export const selectEntitiesPaises = createSelector(
  selectPaisesState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectPaisesError = createSelector(selectPaisesState, getError);

// MemoizedSelector<object,any>
export const selectPaisesIsLoading = createSelector(
  selectPaisesState,
  getIsLoading
);
